// extracted by mini-css-extract-plugin
export default {"spinner":"APLoader_spinner__awDHh","spin":"APLoader_spin__rFVUe"};